import { useContextSelector } from 'use-context-selector';
import { useApolloClient } from '@apollo/client';
import { useAssetId } from '../../../shared';
import { DndOpsContext } from '../contexts/DndOpsContext';
import { useAssetDndZone } from '../contexts/DndZoneContext';
import { isValidMoveOp } from '../utils/op-checks';

/**
 * returns true if a folder is the target of a valid move operation
 * used for highlighting
 * */
export const useIsFolderMoveTarget = (folderId: string) => {
  const currentZone = useAssetDndZone();
  const assetId = useAssetId();
  const { cache } = useApolloClient();
  return useContextSelector(DndOpsContext, ({ active, draggingIds, over }) => {
    if (!active?.id || assetId !== over?.id) return null;
    if (folderId !== over?.id) return null;

    if (currentZone === 'project-panel' && over.zone === 'project-nav')
      return false;
    if (currentZone === 'project-nav' && over.zone === 'project-panel')
      return false;

    return isValidMoveOp({
      activeInfo: active,
      draggingIds,
      overInfo: over,
      cache,
    });
  });
};
